import React, { ComponentProps, PropsWithChildren } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';

interface BadgeProps extends Pick<ComponentProps<typeof Stack>, 'hidden'> {}

export const Badge = ({ children, hidden }: PropsWithChildren<BadgeProps>) => (
    <Stack backgroundColor="green_100" paddingX="2.5" paddingY="1.5" borderRadius="3xl" hidden={hidden}>
        <Text color="validationSuccess" size="b_sm" fontWeight="semibold">
            {children}
        </Text>
    </Stack>
);
